import type { SVGProps } from "react";

/** DocLens logomark — magnifying glass over a document grid. */
export function Lens(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="3" y="3" width="13" height="16" rx="2" />
      <path d="M7 8h6" />
      <path d="M7 12h4" />
      <circle cx="16" cy="16" r="4" />
      <path d="M19 19l2.5 2.5" />
    </svg>
  );
}
